<div *ngIf="values.length" [fxLayout]="params.horizontal ? 'row' : 'column'" [title]="title">
  <span *ngFor="let value of values">{{ value }}</span>
</div>
<span *ngIf="!values.length">{{ 'common.noValue' | translate }}</span>
